import React from "react";
import { useNav } from "../context/NavContext";
import { analytics } from "@/lib/analytics";

interface Props {
  cmpIds: Array<number | string>;
  setCmpIds: React.Dispatch<React.SetStateAction<Array<number | string>>>;
  page: string;
  lang: "es" | "en";
}

/**
 * Floating "Comparar (n)" bar that appears whenever the user has at
 * least one product staged in the comparator. Hidden on the compare
 * page itself so it doesn't overlap the table.
 */
export function CompareStickyBar({ cmpIds, setCmpIds, page, lang }: Props) {
  const { nav } = useNav();
  const count = cmpIds.length;
  if (count === 0 || page === "compare") return null;

  const labelGo = lang === "es" ? "Comparar" : "Compare";
  const labelClear = lang === "es" ? "Limpiar" : "Clear";

  return (
    <div
      role="region"
      aria-label={labelGo}
      data-testid="compare-sticky-bar"
      style={{
        position: "fixed",
        left: "50%",
        transform: "translateX(-50%)",
        bottom: "calc(76px + env(safe-area-inset-bottom, 0px))",
        zIndex: 60,
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "10px 14px",
        borderRadius: 999,
        background: "var(--bg, #111)",
        color: "var(--tx, #fff)",
        border: "1px solid var(--bd2, #2a2a2a)",
        boxShadow: "0 12px 32px rgba(0,0,0,.25)",
        maxWidth: "calc(100vw - 24px)",
      }}
    >
      <span
        aria-hidden="true"
        style={{
          fontSize: 11, fontWeight: 800, padding: "3px 8px",
          borderRadius: 999, background: "linear-gradient(135deg,#7c3aed,#2563eb)",
          color: "#fff",
        }}
      >
        {count}/3
      </span>
      <button
        type="button"
        onClick={() => { analytics.compareView({ items: count, lang }); nav("compare"); }}
        className="btn bp"
        style={{ fontSize: 13, fontWeight: 700, padding: "8px 14px", borderRadius: 999 }}
        data-testid="compare-sticky-go"
      >
        ⚖️ {labelGo} →
      </button>
      <button
        type="button"
        onClick={() => { analytics.compareClear({ lang }); setCmpIds([]); }}
        aria-label={labelClear}
        title={labelClear}
        style={{
          background: "transparent", border: "none", color: "var(--tx3, #999)",
          cursor: "pointer", fontSize: 18, lineHeight: 1, padding: "4px 6px",
        }}
        data-testid="compare-sticky-clear"
      >
        ×
      </button>
    </div>
  );
}

export default CompareStickyBar;